<template>
    <li
        class="l-ss-c-enum-tree-node"
        :class="{
            'l-ss-c-enum-tree-node-open': isOpen,
            'l-ss-c-enum-tree-node-highlighted': isHighlighted
        }">
        <div
            class="l-ss-c-enum-tree-node-inner"
            @click="toggle">
            <app-checkbox
                :value="isActive"
                @change="isActive = !isActive"
                @click.native.stop>
                <span v-html="node.title"></span>
            </app-checkbox>
            <div class="l-ss-c-enum-tree-node-icon-wrapper">
                <i
                    v-if="node.hasVisibleChild"
                    v-html="iconArrowRight"
                    class="l-ss-c-enum-tree-node-icon"></i>
            </div>
        </div>
        <slot v-bind="{ isOpen }"></slot>
    </li>
</template>

<script>
    import { ref, computed, inject } from '@vue/composition-api';

    import AppCheckbox from '@/core/components/common/app-checkbox.vue';

    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';

    export default {
        name: 'tree-enum-node',
        components: { AppCheckbox },
        model: {
            prop: 'value',
            event: 'change',
        },
        props: {
            value: {
                type: Set,
            },
            node: {
                type: Object,
            },
        },
        setup(props, { emit }) {
            const isOpen = ref(false);

            const toggle = () => {
                isOpen.value = !isOpen.value;
                onToggleOpen();
            };

            const activeCategories = computed({
                get() {
                    return props.value;
                },
                set(value) {
                    emit('change', value);
                },
            });

            const getChildNodes = (node) => {
                let childNodes = [...node.child];

                node.child.forEach((childNode) => {
                    childNodes.push(...getChildNodes(childNode));
                });

                return childNodes;
            };

            const isActive = computed({
                get() {
                    return !!activeCategories.value.has(props.node.id);
                },
                set(value) {
                    const childNodes = getChildNodes(props.node);

                    const newActiveCategories = new Set(activeCategories.value);

                    if (value) {
                        newActiveCategories.add(props.node.id);

                        childNodes.forEach((childNode) => {
                            newActiveCategories.add(childNode.id);
                        });

                        const checkParent = (node) => {
                            if (!node.parent) {
                                return;
                            }

                            for (let childNode of node.parent.child) {
                                if (!newActiveCategories.has(childNode.id)) {
                                    return;
                                }
                            }

                            newActiveCategories.add(node.parentId);
                            checkParent(node.parent);
                        };

                        checkParent(props.node);
                    } else {
                        newActiveCategories.delete(props.node.id);

                        const deleteParentFromActive = (node) => {
                            if (node.parent) {
                                newActiveCategories.delete(node.parentId);
                                deleteParentFromActive(node.parent);
                            }
                        };

                        deleteParentFromActive(props.node);

                        childNodes.forEach((childNode) => {
                            newActiveCategories.delete(childNode.id);
                        });
                    }

                    activeCategories.value = newActiveCategories;
                },
            });

            const isHighlighted = computed(() => {
                if (isActive.value) {
                    return false;
                }

                let activeNodesCount = 0;

                const childNodes = getChildNodes(props.node);

                childNodes.forEach((childNode) => {
                    if (activeCategories.value.has(childNode.id)) {
                        ++activeNodesCount;
                    }
                });

                return activeNodesCount >= 1 && activeNodesCount !== childNodes.length;
            });

            isOpen.value = isHighlighted.value;

            const onToggleOpen = inject('onToggleOpen');

            return {
                iconArrowRight,
                isOpen,
                toggle,
                activeCategories,
                isActive,
                isHighlighted,
            };
        },
    };
</script>

<style scoped>

</style>
